export default "__VITE_ASSET__jFJwoKnr__"